import type { Encyclopedia } from '.';
import { action } from '@play-co/replicant';
import { defineActions } from '../utils';

export const encyclopediaActions = defineActions<Encyclopedia>()({
  clearEncyclopediaNotifications: action((state) => {
    state.encyclopedia.speciesNotification = {};
  }),
});
